<script>
  import Header from "./Header.svelte";
</script>

<Header>32 Bit Edition</Header>
<div class="body">
  <slot></slot>
</div>

<style>
  .body {
    max-width: 450px;
  }
  /* :global(.body p) {
    margin: 0;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :global(.body p + p) {
    margin: 0;
    margin-top: 10px;
    margin-bottom: 0px;
  } */

  @media screen and (max-width: 720px) {
    .body {
      max-width: initial;
    }
  }
</style>
